angular.module('cvsApp').factory('getFavoriteStoresModel',['commonModel',function(CM) {	
	'use strict';
	var getFavoriteStoresModel = function(){

		var self = this;

		var apiResponse = {};

		this.setResponse = function(data){
			CM.setResponse(data);
		}

		this.getResponse = function(){
			apiResponse = CM.getResponse();
			return self;
		}

		this.showView = function(){
			if(apiResponse.isViewError){
				return !apiResponse.isViewError;
			}
			return true;
		}

		this.getError = function(){
			if(apiResponse.showError){
				return apiResponse.showError;
			}
			return '';
		}

		var getHeader = function () {
			return apiResponse.response.header;
		}

		this.getFavoriteStores = function(){
			var favStores = [];
			if(!apiResponse.showError && apiResponse.favoriteStore){
				if(_.isArray(apiResponse.favoriteStore)){
					return apiResponse.favoriteStore;
				}else{
					if(apiResponse.favoriteStore)
						favStores.push(apiResponse.favoriteStore);
					return favStores;
				}
			}
			return favStores;
		};
	
	};
	
	return new getFavoriteStoresModel();
}]);